import tz from 'timezone/loaded';

export default function getPacificTime() {
  return tz(new Date(), '%Y-%m-%dT%H:%M:%S', 'America/Los_Angeles');
}
